module.exports = __webpack_public_path__ + "img/etape_construction.ea124357.png";